import { createSelector } from '@reduxjs/toolkit';

import getHostSetting from 'editor/src/store/hostSettings/selector/getHostSetting';
import { HostSettingsState } from 'editor/src/store/hostSettings/types';
import { RootState } from 'editor/src/store/index';

// Input selectors
const selectMultiplePrintAreasGuidelines = (state: RootState) => getHostSetting(state, 'multiplePrintAreasGuidelines');

const selectSpreads = (state: RootState) => state.design.designData?.spreads ?? [];

// Memoized selector
const getMultiplePrintAreasGuidelines = createSelector(
  [selectMultiplePrintAreasGuidelines, selectSpreads],
  (multiplePrintAreasGuidelines, spreads): HostSettingsState['multiplePrintAreasGuidelines'] => {
    // Check cheap conditions first
    if (!multiplePrintAreasGuidelines?.description) {
      return undefined;
    }

    // Check spreads in a single iteration
    let hasSecondaryArea = false;
    let hasOtherArea = false;

    spreads.forEach((spread) => {
      if (!spread?.pages?.length) {
        return;
      }

      if (/back|sleeve|wrist/i.test(spread.name)) {
        hasSecondaryArea = true;
      } else {
        hasOtherArea = true;
      }
    });

    if (hasSecondaryArea && hasOtherArea) {
      return multiplePrintAreasGuidelines;
    }

    return undefined;
  },
);

export default getMultiplePrintAreasGuidelines;
